import Api from "@root/components/api";

export default class AiMutation {    
    async ganerateTasks(prompt, gameType, engine) {
        let result = await Api.postData('/api/ai/generate-tasks', {prompt: prompt, gameType: gameType, engine: engine});
        let lowerCaseGameType = gameType.substring(0,1).toLowerCase() + gameType.substring(1);
        return result[lowerCaseGameType];
    }
}